import { DynamicPropertyType } from 'types/DynamicPropertyType';

import { makeCSVImportError } from '../tree';
import type DynamicGroup from './Group';
import { DynamicProperty } from './Property';

function parseCSVBoolean(value: string): boolean | undefined {
  value = value.trim().toUpperCase();
  switch (value) {
    case 'TRUE':
    case '1':
    case 'YES':
      return true;
    case 'FALSE':
    case '0':
    case 'NO':
      return false;
    default:
      return undefined;
  }
}

export default class Boolean extends DynamicProperty<boolean> {
  type = DynamicPropertyType.BOOLEAN;
  value = false;

  constructor(parent: DynamicGroup, name: string, value: boolean) {
    super(parent, name, value);
    // this.becomeObservable();
  }

  setDefault = () => {
    this.setInitialValue(false);
  };

  toggle = () => {
    this.value = !this.value;
  };

  getString = () => {
    return this.value ? 'true' : 'false';
  };

  getPreviewData = () => {
    return this.value;
  };

  setUsingCSV = (value: string) => {
    const boolVal = parseCSVBoolean(value);
    if (boolVal === undefined) {
      throw makeCSVImportError(
        this,
        `Invalid boolean value: ${JSON.stringify(value)}`
      );
    }
    this.set(boolVal);
  };
}
